import axios from '../axios'

const deleteAvailableRuleApi = async (eventId) => {
    return await axios.delete(`api/teacher/events/${eventId}/delete-available`)
}

export default deleteAvailableRuleApi